<template>
  <div>
    <el-col :span="4">
      <el-input placeholder="标识符" v-model="params.codes"><el-button slot="append" icon="el-icon-search" @click="SearchAction"></el-button>        </el-input>
    </el-col>
   <el-table :data="data" :height="wheight-130" v-loading="loading">

      <el-table-column prop="codes" label="标识符"></el-table-column>
      <el-table-column prop="number" label="次数"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont el-icon-view" @click="selGet(scope.$index, scope.row)">查看详情</i>
            <!-- <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page.sync="params.page"
                :total="total_count" :page-size="params.pageSize">
        </el-pagination>
    </div>
    <el-dialog title="扫码详情" width="70%" :visible.sync="logoff" :before-close="logon">
     <template>
        <el-table :data="data_log" :height="570" v-loading="loading_log">

           <el-table-column prop="codes" label="标识符"></el-table-column>
           <el-table-column prop="user_id" label="用户id"></el-table-column>
           <el-table-column prop="username" label="用户昵称id"></el-table-column>
           <el-table-column prop="goods_name" label="标题"></el-table-column>
           <el-table-column prop="source_from" label="来源"></el-table-column>
           <el-table-column prop="remark" label="备注"></el-table-column>
           <el-table-column prop="created_at" label="扫码时间" width="200">
               <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
           </el-table-column>
         </el-table>
         <div v-if="total_count_log > params_log.pageSize" class="content-padded content-center">
             <el-pagination
                     background
                     layout="prev, pager, next"
                     @current-change="handleCurrentChange1"
                     :current-page.sync="params_log.page"
                     :total="total_count_log" :page-size="params_log.pageSize">
             </el-pagination>
         </div>
     </template>
    </el-dialog>
  </div>

</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getQrcodesMember,getQrcodesMemberLog} from '@/api/publicity'
  export default {
    data () {
      return {
        data: [],
        upload_at:'',
        loading: false,
        logoff:false,
        loading_log:false,
        linksList:[],
        data_log:[],
        total_count: 0,
        total_count_log:0,
        params_log:{
          page: 1,
          pageSize: 10,
        },
        params: {
          page: 1,
          pageSize: 20,
        },
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange () {
        this.getDataList()
      },


      getDataList () {
        this.loading = true
        getQrcodesMember(this.params).then(response => {
          this.data = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      },

      getDataLogList () {
        this.loading_log = true
        getQrcodesMemberLog(this.params_log).then(response => {
          this.data_log = response.data.data.list
          this.total_count_log = response.data.data.total_count
          this.loading_log = false
        })
      },
      handleCurrentChange1(){
        this.getDataLogList()
      },
      SearchAction(){
        this.getDataList()
      },
      selGet(val,row){
        console.log(row)
        this.params_log.codes = row.codes
        this.params_log.page=1
        this.getDataLogList()
        this.logoff=true
      },
      logon(){
        this.logoff=false
      },
      updateDateChange (val) {
          if (val && val.length > 0) {
              this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_upload_at = ''
              this.params.end_upload_at = ''
          }
          this.getDataList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      }
    },
    mounted () {
      this.getDataList();
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
  .num_b{
    width: 130px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// members.vue?bd94c418